import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=65a8ce7c&"
import script from "./accounts.vue?vue&type=script&lang=js&"
export * from "./accounts.vue?vue&type=script&lang=js&"
import style0 from "./accounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports